import { jsx } from "react/jsx-runtime";
import AntDrawer from "antd/es/drawer";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import { CLOSE_ICON_SIZE } from "./Drawer.constants.js";
import './Drawer.css';/* empty css            */
const Drawer = ({
  rootClassName,
  className,
  children,
  title,
  closeIconSize: size = "middle",
  placement = "left",
  ...props
}) => {
  const getCloseIcon = () => {
    return /* @__PURE__ */ jsx(Icon, { name: "cross", ...CLOSE_ICON_SIZE[size] });
  };
  return /* @__PURE__ */ jsx(
    AntDrawer,
    {
      rootClassName: classnames(["perxis-auto-drawer", `perxis-auto-drawer--close-icon-${size}`], rootClassName),
      className,
      closeIcon: getCloseIcon(),
      placement,
      title: title ? /* @__PURE__ */ jsx(Typography.Title, { headingLevel: 5, level: "h4", color: "darkest", children: title }) : null,
      ...props,
      children
    }
  );
};
export {
  Drawer as default
};
//# sourceMappingURL=Drawer.js.map
